import {
  RiFileDamageLine,
  RiFileUnknowLine,
  RiListSettingsFill,
} from "react-icons/ri";
import { Link } from "react-router-dom";
const Menu = ({ user }) => {
  const getIcon = (item) => {
    switch (item.url) {
      case "/main":
        return <RiFileDamageLine />;
      case "/filter":
        return <RiFileDamageLine />;
      case "/requirement":
        return <RiListSettingsFill />;
      default:
        return <RiFileUnknowLine />;
    }
  };
  const setMenuDefault = (item, e) => {
    user.menuDefault = item.ID;
    window.localStorage.setItem("user", JSON.stringify(user));
  }
  return (
    <nav>
      <ul>
        {user.modulos.map((item) => (
          <li key={item.url}>
            <Link
              to={item.url}
              onClick={setMenuDefault.bind(this,item)}
              className={`flex items-center gap-4 mb-2 hover:bg-green-600 py-4 px-10 hover:text-white rounded-lg transition-colors ${item.ID === user.menuDefault ? 'bg-green-600 text-white' : 'text-gray-400' }` }
            >
              {getIcon(item)}
              {item.text}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
export default Menu;